import factory from './icon';
import Svg16x16 from './glyphs/Radio_16x16.svg';
import SvgChecked16x16 from './glyphs/RadioChecked_16x16.svg';

export const Unchecked16x16 = factory(Svg16x16, 16, 16);
export const Checked16x16 = factory(SvgChecked16x16, 16, 16);
